<template>
  <van-tabs v-model:active="active" :style="{ height: clientHeight - 80 + 'px' }">
    <van-tab :title="tools.GetLanguageValue('public.app.购物车')">

      <div class="cart_content" v-if="Carts.Items.length > 0" :style="{ height: clientHeight - 280 + 'px' }">
        <div class="cart_items">
          <div v-for="(item, index) in Carts.Items" :key="index" style="border-bottom: 1px solid #eee">
            <div class="cart_item">
              <div class="item_opt">
                <van-button icon="minus" type="primary" size="mini" @click="MinusCartItem(item)" />
              </div>
              <div class="item_detail">{{ item.Count }} ✖ {{ item.Name }}</div>
              <div class="item_detail_btn">
                <van-icon name="label-o" @click="DetailOrder(item)" />
              </div>
              <div class="item_amount">
                {{ item.Total }}
              </div>
            </div>
            <div class="cart_items_gengduo" v-if="item.ProductType == 200">
              <div class="productCollection_content">
                <div class="productCollection_items" v-for="(item, index) in item.CollectionItems" :key="item.Id">
                  <div class="productCollection_index">{{ index + 1 }}</div>
                  <div class="productCollection_name" @click="DetailOrder(item)">
                    <van-icon name="label-o" />{{ item.Name }}
                  </div>
                  <div class="productCollection_count">{{ item.Count }}</div>

                  <div class="productCollection_price">
                    {{ item.TotalFormat }}
                  </div>

                  <div class="productCollection_manage">
                    <van-button type="primary" icon="minus" size="mini" @click="MinusCartItem(item)">
                    </van-button>
                  </div>
                </div>
              </div>
              <div class="edit_content">
                <van-button @click="editCollection(item)" type="primary" icon="plus" size="mini">
                  {{ tools.GetLanguageValue("public.app.新增") }}
                </van-button>
              </div>

              <!-- <span> 套餐 </span>
                <van-icon name="notes-o" class="icon" /> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 下单信息 -->
      <div class="cart_total_content">
        <div class="cart_total_title" v-if="UserInfo.AccountType == 100">
          <div>{{ tools.GetLanguageValue("public.app.桌台") }}</div>
          <div>{{ UserInfo.Name }}</div>
        </div>

        <div class="cart_total_title">
          <div>{{ tools.GetLanguageValue("public.app.合计") }}</div>
          <div>{{ Carts.TotalFormat }}</div>
        </div>
        <div class="cart_total_tax">
          <div>{{ tools.GetLanguageValue("public.app.税额") }}</div>
          <div>{{ Carts.TaxAmountFormat }}</div>
        </div>
        <div class="cart_total_amount">
          <div>{{ tools.GetLanguageValue("public.app.金额") }}</div>
          <div>{{ Carts.AmountFormat }}</div>
        </div>
        <div class="cart_plan_order">
          <van-button round type="primary" style="width: 70%; height: 30px" @click="PayOrder()">
            {{ tools.GetLanguageValue("public.app.下单") }}
          </van-button>
        </div>
      </div>

      <!-- 空购物车提示 -->
      <div class="cart_tips" v-if="Carts.Items.length == 0">
        <p>
          <svg t="1659185225274" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="3480" width="200" height="200">
            <path
              d="M734.208 354.461538a78.769231 78.769231 0 0 1 73.216 49.703385L866.461538 552.881231V787.692308a78.769231 78.769231 0 0 1-78.76923 78.76923H236.307692a78.769231 78.769231 0 0 1-78.76923-78.76923v-231.699693l59.195076-151.433846A78.769231 78.769231 0 0 1 290.107077 354.461538h444.100923z m-355.209846 212.676924H189.046154L189.046154 787.692308a47.261538 47.261538 0 0 0 42.417231 47.02523L236.307692 834.953846h551.384616a47.261538 47.261538 0 0 0 47.02523-42.417231L834.953846 787.692308v-220.553846h-189.952a133.907692 133.907692 0 0 1-266.003692 0z m355.249231-181.169231H290.067692a47.261538 47.261538 0 0 0-41.865846 25.284923l-2.166154 4.765538L199.286154 535.630769h190.306461l-0.039384 0.590769A15.753846 15.753846 0 0 1 409.6 551.384615a102.4 102.4 0 0 0 204.8 0 15.753846 15.753846 0 0 1 14.848-15.753846h196.450462l-47.576616-119.847384a47.261538 47.261538 0 0 0-38.675692-29.538462l-5.238154-0.275692zM286.168615 106.417231l2.166154 2.363077 114.609231 155.254154a15.753846 15.753846 0 0 1-23.158154 21.070769l-2.166154-2.363077-114.60923-155.214769a15.753846 15.753846 0 0 1 23.158153-21.110154z m244.460308-4.017231a15.753846 15.753846 0 0 1 15.438769 12.603077l0.315077 3.150769v155.254154a15.753846 15.753846 0 0 1-31.192615 3.150769l-0.315077-3.150769V118.153846c0-8.664615 7.049846-15.753846 15.753846-15.753846z m265.688615 3.072a15.753846 15.753846 0 0 1 4.962462 19.298462l-1.614769 2.756923-114.333539 155.175384a15.753846 15.753846 0 0 1-26.978461-15.911384l1.575384-2.756923 114.372923-155.21477a15.753846 15.753846 0 0 1 22.016-3.347692z"
              fill="#dbdbdb" p-id="3481"></path>
          </svg>
        </p>
        <p>{{ tools.GetLanguageValue("public.app.您的购物车是空的") }}</p>
      </div>
    </van-tab>
  </van-tabs>

  <!-- 详细信息 -->
  <van-action-sheet v-model:show="DetailOrderWindow" :title="tools.GetLanguageValue('public.app.详细信息')">
    <AttributeParamsMoudule :Model="CartItemOpt" :key="CartItemOpt.Id" />
  </van-action-sheet>

  <!-- 套餐信息 -->
  <van-action-sheet v-model:show="CollectionDetailWindow" :title="tools.GetLanguageValue('public.app.套餐信息')">
    <StoreCartCollectionModule :Model="CartItemOpt" @GetShoppingCart="GetShoppingCartComplete()" />
  </van-action-sheet>

  <!-- 选择地址 -->
  <van-action-sheet v-model:show="AddressWindow" :title="tools.GetLanguageValue('public.app.选择地址')">

    <van-address-list v-model="chosenAddressId" :list="AddressList" @click-item="ClickAddress" @add="AddAddress"
      @edit="EditAddress" :disabled-list="DisabledAddressList" default-tag-text="默认" />

  </van-action-sheet>

  <!-- 选择支付方式 -->
  <van-action-sheet v-model:show="PayMethodsWindow" :title="tools.GetLanguageValue('public.app.选择支付方式')">

    <div class="pays_content">
      <!-- {{ item }} -->
      <div v-for="(item, index) in PayMethodsList" :key="index" class="pays_content_item" @click="CheckPayMethod(item)">
        <van-image width="3rem" height="3rem" fit="contain" :src="item.PictureFormat" />
        {{ item.Name }}
      </div>
    </div>

  </van-action-sheet>

  <!-- 选择运输方式 -->
  <van-action-sheet v-model:show="PayMethodsWindow" :title="tools.GetLanguageValue('public.app.选择支付方式')">

    <div class="pays_content">
      <!-- {{ item }} -->
      <div v-for="(item, index) in PayMethodsList" :key="index" class="pays_content_item" @click="CheckPayMethod(item)">
        <van-image width="3rem" height="3rem" fit="contain" :src="item.PictureFormat" />
        {{ item.Name }}
      </div>
    </div>

  </van-action-sheet>

  <br />
  <br />
  <br />
  <br />

  <TakeOutTabbar active="storeshoppingcart" />
</template>
<script >
import TakeOutTabbar from "../../components/tabbars/TakeOutTabbar.vue"
import addressfield from "../../components/addressfield.vue"
import paymethods from "../../components/pay-methods.vue"
import freightTransport from "../../components/freightTransport.vue"
import AttributeParamsMoudule from "../../components/AttributeParamsMoudule.vue"
import StoreCartCollectionModule from "../../components/Stores/StoreCartCollectionModule.vue"

import axios from "../../commons/AxiosMethod.js"
import commons from "../../commons/commons.js"
import tools from "../../commons/tools.js"
import { showToast, Tab, Tabs } from "vant"
import { createApp } from "vue"

export default {
  data () {
    return {
      FreightTransportMethods: [], // 运输方式
      FreightTransportOpt: [], // 选择支付方式

      PayMethodsWindow: false, // 选择支付方式
      PayMethodsList: [], // 支付列表
      PayMethodOpt: {}, // 选择支付方式
      DisabledAddressList: [], // 不可用地址
      AddressList: [], // 地址列表
      chosenAddressId: '', // 选中地址
      AddressWindow: false,
      tools: tools,
      active: "购物车",
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      Carts: {
        TableName: "",
        Items: [],
        ItemsPlace: []
      }, // 购物车项目

      PaymenthodId: "", // 选中支付方式
      AddressId: "", // 选中支付地址
      FreightTransportId: "", // 货运地址
      Remarks: "",

      DetailOrderWindow: false, // 详细信息页面
      CartItemOpt: {
        CollectionItems: []
      }, // 选中购物车项目

      UserInfo: {}, // 用户信息

      CollectionDetailWindow: false, // 套餐详细页面
      TableId: ""
    }
  },
  name: "App",

  mounted () {
    this.TableId = localStorage.getItem("Cache-TableId")

    this.GetShoppingCartComplete()
    this.GetAddress()
    this.GetPayMethods()
  },

  components: {
    TakeOutTabbar,
    addressfield,
    paymethods,
    freightTransport,
    AttributeParamsMoudule,
    StoreCartCollectionModule
  },
  methods: {
    // 创建订单
    CreateOrder () {
      axios.apiMethod(
        "/sys/SystemData/CreateOrder",
        "get",
        {
          PayMethodId: this.PayMethodOpt.Id,
          AddressId: this.chosenAddressId,
          FreightTransportId: this.FreightTransportOpt.Id

        },
        (result) => {
          if (result.Code == 200) {

          } else {
            showToast(result.Msg)
          }
        },
        (e) => { }
      )
    },
    // 选择支付方式
    CheckPayMethod (item) {
      this.PayMethodOpt = item
      this.PayMethodsWindow = false
    },
    // 获取支付方式
    GetPayMethods () {
      axios.apiMethod(
        "/sys/SystemData/GetPayMethods",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.PayMethodsList = result.Data
          } else {
            showToast(result.Msg)
          }
        },
        (e) => { }
      )
    },
    // 新增地址
    AddAddress () {
      this.$router.push({
        name: "addressedit",
        query: {
          id: "add"
        }
      })
    },
    // 编辑地址
    EditAddress (item, index) {
      this.$router.push({
        name: "addressedit",
        query: {
          id: item.id
        }
      })
    },
    // 选中地址
    ClickAddress (item) {
      this.AddressWindow = false
      this.PayMethodsWindow = true
    },
    // 获取地址
    GetAddress (item) {
      axios.apiMethod(
        "/api/User/GetUserAddress",
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.AddressList = []
            result.Data.forEach((element) => {
              this.AddressList.push({
                id: element.Id,
                name: element.Name,
                tel: element.Phone,
                address: element.DetailedAddress,
                isDefault: element.Default,
                isDefault: element.Default
              })
            })
          } else {
            showToast(result.Msg)
          }
        },
        (e) => { }
      )
    },
    // 查看套餐详细信息
    CollectionItemDetail (item) {
      this.CartItemOpt = item
      this.CollectionDetailWindow = true
    },
    // 详细信息
    DetailOrder (item) {
      item.CollectionItems = item.children
      this.CartItemOpt = item

      this.DetailOrderWindow = true
    },
    // 编辑套餐
    editCollection (item) {
      this.$router.push({
        path: "takeOutCollectionItems",
        query: {
          cartId: item.Id,
          collectionId: item.ProductId
        }
      })
    },
    // 减少商品
    MinusCartItem (item) {
      axios.apiMethod(
        "/Store/StoreOrder/CutShoppingCart",
        "post",
        { Id: item.Id },
        (result) => {
          if (result.Data.IsSuccess) {
            this.GetShoppingCartComplete()
          }
          showToast(result.Data.Msg)
        },
        (e) => { }
      )
    },
    // 下单
    PayOrder () {
      this.AddressWindow = true

      // 创建订单
      // 选择地址
      // 选择支付方式
      // 支付订单
      // 通知厨房送出
    },

    // 获取购物车
    GetShoppingCartComplete () {
      axios.apiMethod(
        "/TakeOuts/ShoppingTrolley/GetMyShopping",
        "get",
        {
        },
        (result) => {
          this.Carts = result.Data
          for (var i = 0; i < this.Carts.Items.length; i++) {
            if (this.Carts.Items[i].Id == this.CartItemOpt.Id) {
              this.CartItemOpt = this.Carts.Items[i]
              console.log(this.CartItemOpt.CollectionItems)
            }
          }

          if (result.Code == 200) {
            /*

    DetailOrder(item) {
      item.CollectionItems = item.children;
      this.CartItemOpt = item;

*/
          } else {
            showToast(result.Msg)
          }
        },
        (e) => { }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.pays_content {
  padding: 5px;
  width: 95%;
  min-height: 400px;

  .pays_content_item {
    margin: 0 auto;
    width: 90% !important;
    background-color: aqua;
    border: 1px solid #666;
    margin-top: 8px;
    border-radius: 5px;
  }
}

.cart_title {
  position: fixed;
  width: 100%;
  height: 40px;
  z-index: 50000000;
}

.cart_content {
  overflow: auto;
  padding: 10px;

  .cart_items {
    background-color: #fff;
    margin: 0 auto;
    margin-top: 5px;
    border-bottom: 1px solid #eee;
    overflow: auto;

    .cart_item {
      margin-top: 5px;
      height: 50px;
      line-height: 50px;
      width: calc(100% - 30px);
      padding: 0px 5px;
      display: flex;
      justify-content: space-between;

      .item_opt {
        width: 40px;
        height: 40px;
        line-height: 40px;
      }

      .item_detail {
        width: calc(100% - 140px);
        font-size: 9pt;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        font-family: Avenir, Helvetica, Arial, sans-serif;
      }

      .item_amount {
        width: 100px;
        text-align: right;
        font-size: 11pt;
      }
    }

    .cart_items_gengduo {
      padding: 5px;
      font-size: 9pt;

      .icon {
        font-size: 17pt !important;
      }
    }
  }
}

.cart_total_content {
  max-width: 100%;
  background-color: #fff;
  margin-top: 15px;
  padding: 5px;

  .cart_total_title,
  .cart_total_tax,
  .cart_total_amount {
    border-bottom: 1px solid #eee;
    padding: 5px 20px;
    display: flex;
    justify-content: space-between;
  }

  .cart_plan_order {
    text-align: center;
    margin-top: 15px;
  }
}

.detail_attributes_content {
  min-height: 300px;

  .detail_attributes_items,
  .detail_params_items {
    width: calc(100% - 50px);
    margin: 0 auto;
    padding: 5px 0px;
    border-radius: 5px;
    border: 1px solid #eee;

    .detail_attributes_name,
    .detail_params_name {
      width: calc(100% - 100px);
      margin-left: 5px;
      font-size: 9pt;
    }
  }

  .detail_params_items {
    margin-top: 10px;
  }
}

.content {
  min-height: 300px;

  .content_item {
    .content_item_title {
      width: calc(100% - 100px);
      margin-left: 20px;
      font-size: 15pt;

      .manage {
        font-size: 15pt;
        color: #666;
        float: right;
      }
    }
  }
}

.cart_tips {
  position: fixed;
  top: 200px;
  width: 100%;
  text-align: center;

  .cart_tips_icon {
    font-size: 17pt;
  }
}

.edit_content {
  text-align: right;
}

.productCollection_content {
  padding: 10px;
  position: relative;

  .productCollection_items {
    color: rgb(88, 88, 88);
    display: flex;
    justify-content: space-between;
    width: calc(100% - 20px);
    margin: 0 auto;
    border-bottom: 1px solid #eee;
    margin-top: 8px;

    .productCollection_index {
      font-size: 9pt;
      width: 10px;
    }

    .productCollection_name {
      font-size: 10pt;
      width: 30%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .productCollection_count {
      font-size: 10pt;
    }

    .productCollection_price {
      color: red;
      // text-decoration: line-through;
    }
  }

  .productCollection_editcontent {
    position: absolute;
    bottom: 10px;
    right: 20px;
  }
}
</style>
